"use client";

import { MultiStepForm } from './components/MultiStepForm';
import { CpaProgramFormConfig } from './CpaProgramFormConfig';

export function CpaProgramForm() {
  return (
    <MultiStepForm 
      config={CpaProgramFormConfig}
      className="cpa-program-form"
    />
  );
} 